<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-dialog customerEDIInfo"
    :style="$cookies.get('comp-id') === $cookies.get('ownr-id') ? 'width: 900px !important;' : ''"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text pa-4" primary-title>{{
        options.item.action == 'add' ? 'Add ' + title : 'Modify ' + title
      }}</v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="pt-6 v-dialog-1 dialog-partner-detail">
      <v-row>
        <system-progress
          :sysloading="isLoading"
          :sysloadingTitle="sysloadingTitle"
        ></system-progress>
        <v-col cols="7" class="pb-0 pl-6">
          <v-label>{{ $t('lbl.partners.partnerInfo') }}</v-label>
        </v-col>
        <v-col cols="5" class="pl-3 pb-0">
          <v-label>{{ $t('lbl.identification.ediInfo') }}</v-label>
        </v-col>
      </v-row>
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="7">
            <v-form ref="form" class="pt-2 dialog-content form-identification"
              ><v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="pa-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.partners.partnerId') }}
                  </v-label>
                  <v-text-field
                    ref="prnrId"
                    v-model="editedItem.data[0].prnrId"
                    :rules="[
                      validationUtils.required,
                      validationUtils.emailIdRules,
                      validationUtils.max(50),
                    ]"
                    :disabled="!$auth.manage"
                    :readonly="editedIndex > -1"
                    heigth="30"
                    solo
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="pa-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.partners.partnerName') }}
                  </v-label>
                  <v-text-field
                    ref="prnrNm"
                    v-model="editedItem.data[0].prnrNm"
                    :rules="[validationUtils.required, validationUtils.max(50)]"
                    :disabled="!$auth.manage"
                    heigth="30"
                    solo
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mb-1">
                <v-col lg="12" class="pa-0">
                  <v-label>
                    <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                    {{ $t('lbl.partners.contactPersonName') }}
                  </v-label>
                  <v-text-field
                    ref="cnttPrn"
                    v-model="editedItem.data[0].cnttPrn"
                    :rules="[validationUtils.required, validationUtils.max(50)]"
                    :disabled="!$auth.manage"
                    solo
                    heigth="30"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ml-0 mr-0 mb-1">
                <v-col cols="12" class="pa-0">
                  <v-row class="ma-0 check-row-partner">
                    <v-label>
                      <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                      {{ $t('lbl.partners.emailAddress') }}
                    </v-label>
                  </v-row>
                  <v-row class="ma-0">
                    <v-col cols="12" class="map-text-field inline-block-component pa-0">
                      <v-text-field
                        ref="email"
                        v-model="editedItem.data[0].email"
                        :rules="[
                          validationUtils.required,
                          validationUtils.max(50),
                          validationUtils.emailRules,
                        ]"
                        :readonly="editedIndex > -1"
                        @input="setCheckStatus()"
                        :disabled="!$auth.manage"
                        heigth="30"
                        solo
                      ></v-text-field>
                      <v-btn
                        class="ml-3 check-btn-partner"
                        :color="checkBtnColor"
                        @click="checkEmailPartner()"
                        v-if="editedIndex === -1"
                        :disabled="!$auth.manage"
                      >
                        <v-icon x-small>{{ checkBtnIcon }}</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0">
                <v-col cols="12" class="pa-0">
                  <v-label>{{ $t('lbl.identification.remark') }}</v-label>
                  <v-textarea
                    v-model="editedItem.data[0].remark"
                    :disabled="!$auth.manage"
                    height="60"
                    counter="200"
                    solo
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-col cols="5" class="pl-1">
            <v-row class="ml-0 mb-6">
              <v-col cols="12">
                <v-form
                  ref="formEDI"
                  class="dialog-content form-identification edi-iden-partner-list add-partner-dialog pr-0"
                >
                  <v-row class="ml-0 mr-0">
                    <v-col lg="6" class="pa-0">
                      <v-label>{{ $t('lbl.identification.ediID') }}</v-label>
                    </v-col>
                    <v-col lg="4" class="pa-0 ml-2">
                      <v-label>{{ $t('lbl.identification.qualifier') }}</v-label>
                    </v-col>
                    <v-col lg="1" class="pa-0 ml-3">
                      <v-icon v-if="$auth.manage" dense @click="addEDI()">mdi-plus</v-icon>
                    </v-col>
                  </v-row>
                  <v-row
                    class="ml-0 mr-0 mb-3 edi-identification"
                    v-for="(item, index) in listEDI"
                    :key="item.id"
                  >
                    <v-col lg="6" class="pa-0">
                      <v-text-field
                        :ref="'EDI_' + item.id"
                        :maxlength="50"
                        solo
                        hide-details
                        v-model="item.srId"
                        :disabled="item.status != 'I'"
                        :readonly="item.status != 'I'"
                        :class="[item.status != 'I' ? 'custome-edi-not-allowed' : '']"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="4" class="pa-0 ml-2">
                      <v-text-field
                        :ref="'EDI_' + item.id + '_' + item.id"
                        :maxlength="50"
                        solo
                        hide-details
                        v-model="item.srQlfr"
                        @change="changeEDI(item, index)"
                        :disabled="item.numOfUse > 0"
                        :readonly="item.numOfUse > 0"
                        :class="[item.numOfUse > 0 ? 'custome-edi-not-allowed' : '']"
                      ></v-text-field>
                    </v-col>
                    <v-col lg="1" class="pa-0 ml-3 mr-0 mt-2">
                      <v-tooltip top :disabled="item.numOfUse == 0" v-if="$auth.manage">
                        <template v-slot:activator="{ on }">
                          <div v-on="on" class="btn-tooltip">
                            <v-icon
                              dense
                              @click="removeEDI(item, index)"
                              :disabled="item.numOfUse > 0"
                              >mdi-minus</v-icon
                            >
                          </div>
                        </template>
                        <span v-html="$t('lbl.processSetup.ediInUseWF')"></span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
            <v-row class="ml-0 mb-0">
              <v-col cols="12" class="pb-0">
                <v-label>{{ $t('lbl.common.characterSet') }}</v-label>
              </v-col>
            </v-row>
            <v-row class="ml-0">
              <v-col cols="12">
                <v-form ref="formEDI" class="dialog-content form-identification character-set pa-0">
                  <v-row class="ml-0 mr-0">
                    <v-col
                      lg="12"
                      :class="[$vuetify.theme.dark ? 'pa-0' : 'pa-0 pt-1 d-flex justify-center']"
                    >
                      <v-select
                        v-model="editedItem.data[0].chrSet"
                        class="custom-selectbox select-character-set"
                        :placeholder="$t('lbl.common.characterSet')"
                        :items="characterSetList"
                        height="30"
                        hide-details
                        dense
                        solo
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="ml-0 mr-0 mt-3 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0 pt-2">
          <v-col class="button-col action-col character-set" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-delete btn-popup" @click="removeDialog">{{
                $t('lbl.partners.close')
              }}</v-btn>
              <v-btn
                class="btn btn-popup-search btn-popup"
                color="primary"
                @click="onSave"
                :disabled="!$auth.manage"
                >{{ $t('lbl.partners.save') }}</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <dialogWindow
        ref="warningDialog"
        size="max"
        title="Merge & Compare"
        :detail="add_valid_str"
        @select-ok="focusInvalid"
        color="validation"
      ></dialogWindow>
      <dialogWindow
        ref="successDialog"
        size="max"
        title="Merge & Compare"
        :detail="add_valid_str"
        @select-ok="removeDialogRefesh({})"
        color="success"
      ></dialogWindow>
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag2.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapState } from 'vuex';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import { getEditData } from '@/vue-caas/utils/process';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
    SystemProgress,
  },
  name: 'add-parner-dialog',
  props: {
    id: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  computed: {
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  data() {
    return {
      editedIndex: -1,
      listEDI: [],
      listEDIDelete: [],
      add_valid_str: '',
      idFocus: '',
      checkBtnColor: 'secondary',
      checkBtnIcon: 'fa fa-question',
      editedItem: {
        data: [
          {
            prnrId: '',
            prnrNm: '',
            cnttPrn: '',
            email: '',
            stsCd: '',
            remark: '',
            chrSet: '',
          },
        ],
      },
      customerItem: [],
      lockComp: false,
      characterSetList: [],
      loadFormData: [],
      isLoading: false,
      title: 'Partner',
    };
  },

  watch: {},

  methods: {
    getInitData() {
      return {
        prnrId: '',
        prnrNm: '',
        cnttPrn: '',
        email: '',
        stsCd: '',
        remark: '',
        chrSet: '',
      };
    },

    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateParnertProcessInfo', params);
    },
    addEDI() {
      let index = this.listEDI.length > 0 ? this.listEDI[this.listEDI.length - 1].id + 1 : 1;
      this.listEDI.push({
        id: index,
        srId: '',
        srQlfr: '',
        status: 'I',
        numOfUse: 0,
      });
    },
    removeEDI(item, index) {
      if (item.status != 'I') {
        this.listEDI[index].status = 'D';
        this.listEDIDelete.push(this.listEDI[index]);
      }
      this.listEDI.splice(index, 1);
    },
    changeEDI(item, index) {
      if (item.status != 'I') {
        this.listEDI[index].status = 'U';
      }
    },
    onSave() {
      try {
        this.formHasErrors = false;

        const checkList = ['prnrId', 'prnrNm', 'cnttPrn', 'email'];
        Object.keys(this.editedItem.data[0]).forEach((key) => {
          if (this.$refs[key] !== undefined && checkList.includes(key)) {
            if (!this.editedItem.data[0][key] || this.editedItem.data[0][key] === '') {
              this.formHasErrors = true;
              this.$refs[key].validate(true);
            }
          }
        });

        if (this.formHasErrors) return;

        if (this.editedIndex === -1 && this.checkBtnColor != 'success') {
          this.add_valid_str = this.$t('msg.partners.chkprnrDup');
          this.$refs.warningDialog.dialog = true;
          return;
        }

        if (!this.formHasErrors) {
          this.isLoading = true;
          let num = this.listEDI.findIndex((e) => e.srId == '');
          if (num > -1) {
            let index = this.listEDI[num];
            return this.$refs[
              `EDI_${index.id}${index.srId == '' ? '' : '_' + index.id}`
            ][0].focus();
          }

          let arrChk = this.listEDI.map((e) => {
            return e.srId + e.srQlfr + e.orgCompId;
          });
          let isDuplicate = arrChk.findIndex((e, i) => {
            return arrChk.indexOf(e) != i;
          });

          if (isDuplicate > -1) {
            this.isLoading = false;
            this.add_valid_str = this.$t('msg.partners.dupEDI');
            this.$refs.warningDialog.dialog = true;
            this.idFocus = `EDI_${isDuplicate + 1}`;
            return;
          }

          this.editedItem.data[0].edi_list = this.listEDIDelete.concat(
            this.listEDI.filter((e) => e.status),
          );
          this.editedItem.data[0].edi_list.map((e) => {
            e.srQlfr = e.srQlfr.trim();
          });

          if (this.editedIndex > -1) {
            this.$store.dispatch('updatePartner', this.editedItem.data[0]).then(async () => {
              console.log('--------- Finished Edit Partner ----------');
              this.add_valid_str = this.$t('msg.partners.saveModifyitionalPartner');

              let editedData = getEditData(this.editedItem.data[0], this.loadFormData);
              editedData.partnerId = this.editedItem.data[0].id;
              editedData.partnerNm = this.editedItem.data[0].prnrNm;
              await this.sendActivate(this.editedItem.data[0].prnrId, 'Partner', editedData);
              this.isLoading = false;
              this.$refs.successDialog.dialog = true;
            });
          } else {
            this.$store.dispatch('checkPartner', this.editedItem.data[0]).then(() => {
              const tmp = this.$store.getters.partnerCheckResult;
              if (tmp === '') {
                this.$store.dispatch('insertPartner', this.editedItem.data[0]).then(() => {
                  console.log('--------- Finished Add Partner ----------');
                  this.add_valid_str = this.$t('msg.partners.saveAdditionalPartner');
                  this.isLoading = false;
                  this.$refs.successDialog.dialog = true;
                });
              } else {
                this.isLoading = false;
                this.add_valid_str = this.$t('msg.partners.prnrEmailDup');
                this.$refs.warningDialog.dialog = true;
                this.idFocus = 'prnrId';
                return;
              }
            });
          }
        }
      } catch (err) {
        this.isLoading = false;
        this.add_valid_str = `Exception occured.\nReason: ${err}`;
        this.$refs.warningDialog.dialog = true;
      }
    },
    focusInvalid() {
      let self = this;
      setTimeout(() => {
        if (self.idFocus != 'prnrId') self.$refs[self.idFocus][0].focus();
        else self.$refs.prnrId.focus();
      }, 300);
    },
    removeDialogRefesh(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      let data = {};
      this.$emit('search', data);
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    checkEmailPartner() {
      if (this.editedItem.data[0].email.length > 0) {
        this.$store.dispatch('checkEmailPartner', this.editedItem.data[0]).then((res) => {
          if (!res) {
            this.setCheckStatus('S');
          } else {
            this.setCheckStatus('E');
          }
        });
      }
    },
    setCheckStatus(val) {
      if (val === 'S') {
        this.checkBtnColor = 'success';
        this.checkBtnIcon = 'fa fa-check';
      } else if (val === 'E') {
        this.checkBtnColor = 'error';
        this.checkBtnIcon = 'fa fa-times';
      } else {
        this.checkBtnColor = 'secondary';
        this.checkBtnIcon = 'fa fa-question';
      }
    },
    getEDIList() {
      this.listEDIDelete = [];
      const params = {
        prnrId: this.editedItem.data[0].prnrId,
      };
      this.$store.dispatch('getPrnrEdiListNew', params).then(() => {
        this.listEDI = [];
        if (this.$store.getters.prnrEdiIdList.length > 0) {
          this.$store.getters.prnrEdiIdList.map((e, i) => {
            this.listEDI.push({
              id: i + 1,
              srId: e.srId,
              srQlfr: e.srQlfr,
              status: e.status,
              numOfUse: e.numOfUse,
              orgCompId: e.orgCompId,
            });
          });
        }
      });
    },
    getCharacterSetList() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'C06' }).then(() => {
        let characterSetList = this.$store.getters['caascommon/comCdList'];
        characterSetList.map((item) => {
          this.characterSetList.push({ text: item.text, value: item.value });
        });
      });
    },
  },

  created() {
    if (this.options.item.title) {
      this.title = this.options.item.title;
    }
    if (this.options.item.action != 'add') {
      let data = this.options.item.data;
      this.editedItem.data[0] = Object.assign({}, this.getInitData(), data);
      this.loadFormData = Object.assign({}, this.getInitData(), data);
      this.editedIndex = data.id;
      this.getEDIList();
    }

    if (this.editedItem.data[0].compId) this.lockComp = true;
    else this.editedItem.data[0].compId = this.$cookies.get('comp-id');

    this.$store.dispatch('getCompanyListSetup').then(() => {
      console.log('--------- Finished to process Company List ----------');
      this.$store.getters.companiesForSetup.map((e) => {
        this.customerItem.push({ text: e.compNm, value: e.compId });
      });
    });
    this.getCharacterSetList();
  },

  mounted() {},
};
</script>

<style>
.form-identification .check-btn-partner {
  margin-top: 5px;
  min-width: 20px !important;
}
.check-row-partner {
  height: 22px;
}
.dialogs .dialog-drag.customerEDIInfo .dialog-body {
  padding-top: 0px !important;
  background-color: #3b3e49 !important;
}
.row.edi-identification {
  height: 30px;
}
.edi-iden-partner-list {
  min-height: 350px;
  max-height: 350px;
  overflow-y: auto;
}
.custome-edi-not-allowed input {
  cursor: not-allowed;
}
.form-identification {
  margin-bottom: -10px !important;
}
.select-character-set .v-input__control .v-input__slot {
  width: 270px !important;
}
</style>
